import PhotoGallery from "./Gallery/PhotoGallery";

export default function VehiclePhotos() {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <PhotoGallery />
    </div>
  );
}
